export default __webpack_public_path__ + "static/media/i037vp.239ccec7.webp";